import React, { useEffect, useRef, useState } from 'react';

import { Icon } from 'components';

import { Container, IFrame, Content } from './styles';
import useEventBus from 'hooks/useEventBus';

const pdfUrl = require('assets/LGPD.pdf').default;

const PDFModal: React.FC = () => {
  const eventBus = useEventBus();
  const [hasError] = useState(false);
  const [show, setShow] = useState(false);
  const iFrameRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const showPdfModal = () => {
      setShow(true);
    };
    eventBus.addEventListener('showPdfModal', showPdfModal);
    return () => {
      eventBus.removeEventListener('showPdfModal', showPdfModal);
    };
  }, []);

  return (
    <Container isShow={show}>
      <div onClick={setShow.bind(null, false)} className="overlay" />
      <span onClick={setShow.bind(null, false)}>
        <Icon size={2} name="close" color={1000} />
      </span>
      <Content>
        <IFrame ref={iFrameRef} src={pdfUrl} hasError={hasError} />
      </Content>
    </Container>
  );
};

export default PDFModal;
